import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "f-textarea__required"
}
const _hoisted_3 = { class: "f-textarea__text" }
const _hoisted_4 = ["value", "disabled"]

import { ref, computed, watch, inject, onMounted, onUnmounted } from 'vue';
import { isNoE } from '@/utils/obj-utils';
import { FormTextareaEmits, FormTextareaProps, FormTextareaRef } from '@/types/form/form-textarea';
import { DynamicFormContext } from '@/types/form/dynamic-form';
import utils from '@/utils';
import { FormElMsgData } from '@/types/form/others/form-el-msg';
import FormElMsg from '@/form/other/FormElMsg.vue';

const FIELD_TYPE = 'form-textarea';

export default /*@__PURE__*/_defineComponent({
  __name: 'FormTextarea',
  props: {
    item: {}
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;
const formContext = inject<DynamicFormContext>('formContext')!;
const textareaRef = ref<HTMLTextAreaElement>();
const value = ref('');
const isRequired = ref(props.item?.fields?.required?.value ?? false);
const isDisabled = ref(false);
const isVisible = ref(true);
const focused = ref(false);
const msg = ref<FormElMsgData>();

const fields = computed(() => props.item?.fields);

const hasValue = computed(() => !utils.obj.isNoE(value.value));
const label = computed(() => fields.value?.label?.value || '');
const placeholder = computed(() => fields.value?.placeholder?.value || '');
const fieldName = computed(() => fields.value?.fieldName?.value || '');

const onMainClick = () => {
  textareaRef.value!.focus();
};
const onFocus = () => {
  focused.value = true;
};
const onBlur = () => {
  focused.value = false;
};
const onInput = (e: InputEvent) => {
  const el = e.target as HTMLTextAreaElement | undefined;
  value.value = el?.value ?? '';
  msg.value = undefined;
  emit('change', FIELD_TYPE, fieldName.value, value.value, value.value);
};

const setRequired = (required: boolean) => {
  isRequired.value = required;
};

const setDisabled = (disabled: boolean) => {
  isDisabled.value = disabled;
};

const setVisible = (visible: boolean) => {
  isVisible.value = visible;
};

const updateValue = (newValue: string) => {
  value.value = newValue || '';
};
const getValue = () => {
  return value.value;
};

const validate = async () => {
  const result = {
    value: value.value,
    valid: true,
    message: '',
  };

  if (!isVisible.value) {
    return result;
  }

  if (isRequired.value && isNoE(value.value)) {
    result.valid = false;
    result.message = fields.value?.requiredMsg?.value || 'This field is required';
    msg.value = {
      type: 'error',
      message: result.message,
    };
    return result;
  }
  msg.value = undefined;
  return result;
};

const getRefData = (): FormTextareaRef => ({
  el: textareaRef.value!,
  type: 'form-textarea',
  name: fieldName.value,
  id: props.item.id,
  visible: isVisible.value,
  setRequired,
  setDisabled,
  setVisible,
  updateValue,
  getValue,
  validate,
});

// Register this component with parent
watch(
  () => props.item,
  () => {
    formContext.regFormEl(getRefData());
  },
  { immediate: true }
);
onMounted(() => {
  formContext.regFormEl(getRefData());
});
onUnmounted(() => {
  formContext.unRegFormEl(getRefData());
});
__expose(() => getRefData());

return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['f-textarea', { disabled: isDisabled.value, 'has-error': msg.value?.type === 'error' }])
      }, [
        _createElementVNode("div", {
          class: "f-textarea__main",
          onClick: onMainClick
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["f-textarea__placeholder", [{ 'as-label': focused.value || hasValue.value }]])
          }, [
            _createElementVNode("span", {
              class: "f-textarea__label",
              innerHTML: focused.value || hasValue.value ? label.value : _unref(utils).string.ifEmpty(placeholder.value, label.value)
            }, null, 8, _hoisted_1),
            (isRequired.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("pre", null, _toDisplayString(_unref(utils).string.ifEmpty(value.value, placeholder.value)), 1),
            _createElementVNode("textarea", {
              value: value.value,
              onFocus: onFocus,
              onBlur: onBlur,
              onInput: onInput,
              disabled: isDisabled.value,
              ref_key: "textareaRef",
              ref: textareaRef
            }, null, 40, _hoisted_4)
          ])
        ]),
        _createVNode(FormElMsg, { msg: msg.value }, null, 8, ["msg"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})